import { request } from '@umijs/max';
import type { IAccountData, ICodeData, ILoginInfo, ITenantInfo, ITicketInfo } from './type';
import { IChooseTenantData } from './type';

/**
 * signIn
 * @param data IAccountData
 * @returns IRes<IUserInfo>
 */
export const signIn = (data: IAccountData) => {
  return request<IRes<ILoginInfo>>('/supertext-uic/auth/login', {
    method: 'POST',
    data,
  });
};

/**
 * getTicket 获取登录所需ticket
 * @param data IAccountData
 * @returns IRes<IUserInfo>
 */
export const getTicket = (data: IAccountData) => {
  return request<IRes<ITicketInfo>>('/supertext-uic/auth/ticket', {
    method: 'POST',
    data,
  });
};

/**
 * getTenantList 获取租户列表
 * @param ticket string
 * @returns IRes<ITenantInfo>
 * **/
export const getTenantList = (ticket: string) => {
  return request<IRes<ITenantInfo[]>>(`/supertext-uic/auth/tenants`, {
    method: 'POST',
    headers: { authToken: `Bearer ${ticket}` }
  })
}

/**
 * chooseTenant 选择租户登录
 * @param data IChooseTenantData
 * @returns IRes<ILoginInfo>
 * **/
export const chooseTenant = (data: IChooseTenantData) => {
  return request<IRes<ILoginInfo>>(`/supertext-uic/auth/multi-tenant-login`, {
    method: 'POST',
    headers: { authToken: `Bearer ${data.ticket}` },
    data: {
      tenant_id: data.tenant_id,
      tenant_code: data.tenant_code,
    }
  })
}

/**
 * signInByCode
 * @param data ICodeData
 * @returns IRes<IUserInfo>
 */
export const signInByCode = (data: ICodeData) => {
  return request<IRes<ILoginInfo>>('/supertext-uic/auth/login/phone', {
    method: 'POST',
    data,
  });
};

/**
 * signOut
 * @returns IRes<boolean>
 */
export const signOut = () => {
  return request<IRes<boolean>>('/supertext-uic/auth/logout', {
    method: 'DELETE',
  });
};

/**
 * getCode
 * @param data { phone: string }
 * @returns <IRes<boolean>>
 */
export const getCode = (data: { phone: string }) => {
  return request<IRes<boolean>>('/supertext-uic/messages/verification', {
    method: 'POST',
    data,
  });
};
/**
 * 修改密码
 */
export const updatePassword = (data: {
  new_password: string;
  old_password: string;
}) => {
  return request<IRes<boolean>>('/supertext-uic/users/password', {
    method: 'POST',
    data,
  });
};
